import { render, staticRenderFns } from "./ZonaRiscoChip.vue?vue&type=template&id=c6659f7c&"
import script from "./ZonaRiscoChip.vue?vue&type=script&lang=js&"
export * from "./ZonaRiscoChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports